var WeightedColors = [
    "success",
    "warning",
    "error",
    "brandHue",
    "blackAlpha",
    "whiteAlpha",
    "gray",
    "red",
    "blue",
    "purple",
    "teal",
    "green",
    "orange",
    "yellow",
    "cyan",
    "pink",
    "light_blue",
    "forest_green",
    "light_orange",
    "fuschia"
];
var Colors = {
    transparent: "transparent",
    brand: "#f15d4b",
    info: "#63B3ED",
    black: "#444",
    trueBlack: "#000",
    white: "#fff",
    gradients: {
        fuschiaOrange: "linear-gradient(89.13deg, #FD65A8 1.21%, #FFA24D 98.74%)",
        fuschiaShades: "linear-gradient(93.34deg, #FD65A8 0.19%, #FD65A8 48.01%, #F295A8 100%)",
        orangeFuschia: "linear-gradient(89.69deg, #F47D6F 0.48%, #FD65A8 99.58%)",
        orangeShades: "linear-gradient(87.97deg, #F47D6F 2.65%, #FFA24D 97.3%)",
        sunset: "linear-gradient(93.16deg, #AD5BD6 0.18%, #FD65A8 51.58%, #FFA24D 99.73%)",
        tealBlue: "linear-gradient(89.41deg, #33B8A9 21.25%, #3399FF 99.16%)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    success: {
        50: "#eaf4ec",
        100: "#e6f6f0",
        200: "#b3e5d3",
        300: "#80d4b5",
        400: "#4dc297",
        500: "#00a86b",
        600: "#008656",
        700: "#006540",
        800: "#00432b",
        900: "#002215"
    },
    warning: {
        50: "#f8f4e6",
        100: "#fff6e6",
        200: "#ffe5b3",
        300: "#ffd380",
        400: "#ffc14d",
        500: "#ffa700",
        600: "#e69600",
        700: "#b37500",
        800: "#805400",
        900: "#4c3200"
    },
    error: {
        50: "#fcecea",
        100: "#ffe9e7",
        200: "#ffbeb8",
        300: "#ff9389",
        400: "#fe6859",
        500: "#fe2712",
        600: "#cb1f0e",
        700: "#98170b",
        800: "#661007",
        900: "#330804"
    },
    brandHue: {
        50: "#f7d1cc",
        100: "#fbb6ae",
        200: "#fda69c",
        300: "#f58173",
        400: "#f56b5a",
        500: "#f15d4b",
        600: "#d94231",
        700: "#df3925",
        800: "#b92210",
        900: "#8d1204"
    },
    gray: {
        50: "#f2f4f5",
        100: "#eeeff1",
        200: "#dde0e2",
        300: "#87919a",
        400: "#65727d",
        500: "#54626f",
        600: "#434e59",
        700: "#323b43",
        800: "#22272c",
        900: "#111416"
    },
    red: {
        50: "#FFECEE",
        100: "#fceaee",
        200: "#f7bfcb",
        300: "#f295a8",
        400: "#ed6b85",
        500: "#e52b50",
        600: "#ce2748",
        700: "#a01e38",
        800: "#731628",
        900: "#450d18"
    },
    blue: {
        50: "#f4f9ff",
        100: "#e6f2ff",
        200: "#99ccff",
        300: "#66b2ff",
        400: "#3399ff",
        500: "#0072e6",
        600: "#0059b3",
        700: "#004080",
        800: "#00264c",
        900: "#000d19"
    },
    yellow: {
        50: "#fffdf2",
        100: "#fffbe6",
        200: "#ffed99",
        300: "#ffe566",
        400: "#ffdc33",
        500: "#ffd300",
        600: "#e6be00",
        700: "#b39400",
        800: "#806a00",
        900: "#4c3f00"
    },
    light_blue: {
        50: "#dcf8ff",
        100: "#b2e5fe",
        200: "#85d2f6",
        300: "#59c0f1",
        400: "#2daeec",
        500: "#1395d2",
        600: "#0474a4",
        700: "#005377",
        800: "#00334a",
        900: "#00131d"
    },
    cyan: {
        50: "#e8fafa",
        100: "#e6f8fd",
        200: "#b3e9f9",
        300: "#80dbf5",
        400: "#4dcdf1",
        500: "#00b7eb",
        600: "#0092bc",
        700: "#006e8d",
        800: "#00495e",
        900: "#00252f"
    },
    purple: {
        50: "#faf3fe",
        100: "#f5ebfa",
        200: "#d6adeb",
        300: "#c284e0",
        400: "#ad5bd6",
        500: "#9932cc",
        600: "#7a28a3",
        700: "#5c1e7a",
        800: "#3d1452",
        900: "#1f0a29"
    },
    teal: {
        50: "#f0fbfb",
        100: "#e6f6f4",
        200: "#99dbd4",
        300: "#66cabe",
        400: "#33b8a9",
        500: "#00a693",
        600: "#009584",
        700: "#007467",
        800: "#00534a",
        900: "#00322c"
    },
    forest_green: {
        50: "#e2fbef",
        100: "#c1ecd6",
        200: "#9ddfbc",
        300: "#79d1a2",
        400: "#55c489",
        500: "#3baa6f",
        600: "#2c8455",
        700: "#1d5f3d",
        800: "#0d3a23",
        900: "#001506"
    },
    green: {
        50: "#f6faec",
        100: "#f0f7eb",
        200: "#d1e7c2",
        300: "#b3d899",
        400: "#94c870",
        500: "#66b032",
        600: "#528d28",
        700: "#3d6a1e",
        800: "#294614",
        900: "#14230a"
    },
    orange: {
        50: "#fbf2ea",
        100: "#fff2e6",
        200: "#ffd7b3",
        300: "#ffbd80",
        400: "#ffa24d",
        500: "#ff7a00",
        600: "#e66e00",
        700: "#b35500",
        800: "#803d00",
        900: "#4c2500"
    },
    light_orange: {
        50: "#fff3dc",
        100: "#fddfb1",
        200: "#faca83",
        300: "#f6b555",
        400: "#f3a025",
        500: "#da870c",
        600: "#a96906",
        700: "#7a4b02",
        800: "#4b2c00",
        900: "#1d0e00"
    },
    fuschia: {
        50: "#fff4f9",
        100: "#ffecf4",
        200: "#feb2d3",
        300: "#fe8cbe",
        400: "#fd65a8",
        500: "#fd3f92",
        600: "#ca3275",
        700: "#982658",
        800: "#65193a",
        900: "#330d1d"
    }
};
export { Colors, WeightedColors };
